








































import Vue from 'vue';

export default Vue.extend({
    name: 'font-selection',
    props: [
        'currentView',
    ],
    computed: {
        currentFont(): string {
            return this.$store.state.currentFont;
        },
    },
    methods: {
        changeView() {
            this.$emit('changeview');
        },
        changeFont(fontName: string) {
            this.$store.commit('changeFont', fontName);
        },
    },
});
